module.exports = __webpack_public_path__ + "media/img/email/ic-tak-gov-outline-370b251eea86ea322d5304a72e5c09dc.png";